import React, { FC } from 'react';

import hexToRGB from 'utils/hexToRgb';

interface Props {
    value: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder: string;
}

const Input: FC<Props> = ({ value, placeholder, onChange }) => {
    const themColor = document.documentElement.style.getPropertyValue('--them-color');

    return (
        <div className="input">
            <input
                className="input__item"
                type="email"
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                style={{ borderColor: `${hexToRGB(themColor, '.7')}` }}
            />
        </div>
    );
};

export default Input;
